export default "__VITE_ASSET__Bh3$Gxhy__"